import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";

import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import { useAuthAgentChangePassword } from "../../../../services/microservice/admin/auth/use-auth-agents";
import { useCreateMiCeluContext } from "../provider/createMiCelu.provider";
import InputPassword from "../../../../components/inputs/InputPassword";

type IFormInput = {
  currentPassword: string;
  password: string;
  confirmPassword: string;
};

const schemaLogin = yup
  .object({
    currentPassword: yup.string().required(" Requerido"),
    password: yup
      .string()
      .min(8, "La contraseña debe tener al menos 8 caracteres")
      .matches(
        /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])([A-Za-z\d]|[^\w\s]){8,}$/,
        "La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número y un carácter especial",
      )
      .notOneOf(
        [yup.ref("currentPassword")],
        "La contraseña es similar o igual a la anterior.",
      )
      .required(" Requerido"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password")], "Las contraseñas no coinciden.")
      .required(" Requerido"),
  })
  .required();

const RecoverStep = () => {
  const [error, setError] = useState<string>("");
  const { mutateAsync: ChangePassword, isLoading } =
    useAuthAgentChangePassword();
  const { setStep } = useCreateMiCeluContext();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaLogin),
  });
  const onSubmit = async (values: IFormInput) => {
    try {
      const res = await ChangePassword(values);
      if (res) {
        toast.success("Contraseña actualizada correctamente");
        setStep(1);
        setError("");
      }
    } catch (error) {
      setError("Credenciales incorrectas");
    }
  };
  return (
    <section className="w-full">
      <h2 className="mb-5 text-center text-3xl font-bold">
        <span className="text-buttonBlack">Actualización contraseña</span>
      </h2>
      {error && <p className="text-md text-critical">{error}</p>}
      <div className="w-full">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            name="currentPassword"
            control={control}
            render={({ field }) => (
              <InputPassword
                {...field}
                classNameContainer="w-full mb-7"
                classNameInput="w-full"
                placeholder="Contraseña actual"
                error={errors.currentPassword?.message}
                required
              />
            )}
          />
          <Controller
            name="password"
            control={control}
            render={({ field }) => (
              <InputPassword
                {...field}
                classNameContainer="w-full mb-7"
                classNameInput="w-full"
                placeholder="Nueva contraseña"
                error={errors.password?.message}
                required
              />
            )}
          />
          <Controller
            name="confirmPassword"
            control={control}
            render={({ field }) => (
              <InputPassword
                {...field}
                classNameContainer="w-full mb-7"
                classNameInput="w-full"
                placeholder="Confirmar contraseña"
                error={errors.confirmPassword?.message}
                required
              />
            )}
          />
          <div className="flex w-full justify-center">
            <PrimaryButton
              title="Actualizar contraseña"
              className={
                "mt-5 rounded-3xl bg-buttonBlack px-5 py-1 text-sm font-normal text-whiteSoft"
              }
              loading={isLoading}
            />
          </div>
        </form>
      </div>
    </section>
  );
};
export default RecoverStep;
